import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import ParticleBackground from "../components/common/ParticleBackground";

export default function Verified() {
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        background: `
          radial-gradient(circle at 50% 0%, rgba(255,110,0,0.15), transparent 40%),
          linear-gradient(180deg, #141414 0%, #2a1208 100%)
        `
      }}
    >
      <ParticleBackground />

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          textAlign: "center",
          px: 2
        }}
      >
        <Typography
          variant="h3"
          sx={{
            color: "#fff",
            textShadow: "0 0 20px rgba(255,110,0,0.6)",
            mb: 3
          }}
        >
          ✅ Cuenta verificada
        </Typography>

        <Typography sx={{ color: "#ccc", mb: 4 }}>
          Ya podés iniciar sesión y comprar en la tienda.
        </Typography>

        <Button
          component={Link}
          to="/login"
          sx={{
            px: 4,
            py: 1.5,
            fontWeight: "bold",
            background: "linear-gradient(90deg, #ff6e00, #ffae00)",
            color: "#000",
            boxShadow: "0 0 10px rgba(255,110,0,0.6)",
            "&:hover": {
              background: "linear-gradient(90deg, #ffae00, #ff6e00)"
            }
          }}
        >
          Ir a Login
        </Button>
      </Box>
    </Box>
  );
}